import React, { useState, useEffect, useReducer } from 'react';
import { validate } from '../../../utils/validators';

import './MyProfileInput.css';

const inputReducer = (state, action) => {
  switch (action.type) {
    case 'CHANGE':
      return {
        ...state,
        value: action.val,
        isValid: validate(action.val, action.validators)
      };
    case 'TOUCH': {
      return {
        ...state,
        isTouched: true
      };
    }
    default:
      return state;
  }
};

const MyProfileInput = (props) => {
  const [inputState, dispatch] = useReducer(inputReducer, {
    value: props.initialValue || '',
    isTouched: false,
    isValid: props.initialValid || false
  });

  const { id, onInput } = props;
  const { value, isValid } = inputState;

  useEffect(() => {
    onInput(id, value, isValid);
  }, [id, onInput, value, isValid]);

  const changeHandler = (event) => {
    dispatch({
      type: 'CHANGE',
      val: event.target.value,
      validators: props.validators
    });
  };

  const touchHandler = () => {
    dispatch({
      type: 'TOUCH'
    });
  };
  const [error, setError] = useState(true);

  const element = props.element === 'input' && (
    <input
      onClick={props.toggleButton}
      id={props.id}
      type={props.type}
      placeholder={props.placeholder}
      onChange={changeHandler}
      onBlur={touchHandler}
      value={inputState.value}
      className={`input-entry ${!inputState.isValid && inputState.isTouched && 'form-control--invalid'}`}
      disabled={props.disabled}
      style={{ color: props.disabled ? '#999999' : '#000' }}
    />
  );

  return (
    <li className="entry-container">
      {element}
      <label className="input-placeholder">{props.label}</label>
      {!inputState.isValid && inputState.isTouched && <p className="error-text">{props.errorText}</p>}
    </li>
  );
};

export default MyProfileInput;
